import React from 'react';

function Trash(props) {
	return (
		<svg height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
	<g fill="#adb5bd" strokeLinecap="butt" strokeLinejoin="miter">
		<path d="M2.79 5.12l0.52 7.39a1.55 1.55 0 0 0 1.54 1.44h5.18a1.55 1.55 0 0 0 1.54-1.44l0.52-7.39" fill="none" stroke="#adb5bd" strokeLinecap="square" strokeWidth="2"/>
		<path d="M5.58 2.79v-1.08a0.78 0.78 0 0 1 0.78-0.78h2.17a0.78 0.78 0 0 1 0.77 0.78v1.08" fill="none" stroke="#adb5bd" strokeLinecap="square" strokeWidth="2"/>
		<path d="M12.09 2.79h-9.3a1.24 1.24 0 0 0-1.24 1.24v0.93h11.78v-0.93a1.24 1.24 0 0 0-1.24-1.24z" fill="none" stroke="#adb5bd" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2"/>
		<path d="M7.44 6.82v5.27" fill="none" stroke="#adb5bd" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2"/>
		<path d="M5.12 6.82l0.31 5.27" fill="none" stroke="#adb5bd" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2"/>
		<path d="M9.77 6.82l-0.31 5.27" fill="none" stroke="#adb5bd" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2"/>
	</g>
</svg>
	);
};

export default Trash;